export default "__VITE_ASSET__BJ35p0f9__"